import * as React from 'react';
/**
 *
 * Original name: analytics download
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29939%3A7096
 *
 */
export const AnalyticsDownloadLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M17 5.5H5.5V17h7.854v1.5H4V4h14.5v8.5H17v-7Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M15 8h-1.5v6.5H15V8Zm-4.5 1.5H12v5h-1.5v-5Zm-3 1.5H9v3.5H7.5V11Zm11 3v3.76l1.074-1.06 1.054 1.068-2.877 2.838-2.894-2.837 1.05-1.07L17 17.768v-3.77h1.5Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
